import React from 'react';
import { useUnit } from 'effector-react';
import { CreatePortalEntity, CreatePortalEntityType } from '@nx-frontend/features/create-portal-entity';
import { $ModalStore } from '@nx-frontend/shared/ui/modal';
import { CreatePortalEntityPayload, PopupType } from '@nx-frontend/shared/types';

export function CreatePortalEntityPopup() {
  const [modalStore] = useUnit([$ModalStore]);

  const modal = modalStore.find((m) => m.content === PopupType.CREATE_PORTAL_ENTITY);
  const payload = modal?.payload as CreatePortalEntityPayload;
  const entityType = payload?.entityType as CreatePortalEntityType;

  return (
    <div className="mt-5">
      {payload && (
        <CreatePortalEntity entityType={entityType} menuType={payload.menuType} parentId={payload.parentId} />
      )}
    </div>
  );
}
